import { useQuery, gql } from "@apollo/client"

const CATEGORIES_FIELDS = `
    id
    name
    description
    icon
    groups { id }
    locations { id }
    items {     
      count
      lastUpdatedAt
      lastUpdatedAuthor { firstName lastName avatar { key } }
    }
    author { id firstName lastName avatar { key } }
    createdAt
    updatedAt
`

const CATEGORIES_QUERY = gql`
  query Categories($filter: CategoryFilterInput) {
    categories(filter: $filter) {
      ${CATEGORIES_FIELDS}
    } 
  }
`

const CATEGORIES_CREATED_SUBSCRIPTION = gql`
  subscription 
    categoryCreated {
      categoryCreated {
        ${CATEGORIES_FIELDS}
      }
    }
`
const CATEGORIES_UPDATED_SUBSCRIPTION = gql`
  subscription 
    categoryUpdated {
      categoryUpdated {
        ${CATEGORIES_FIELDS}
      }
    }
`

const subscribe = (result) => () =>
  [
    result.subscribeToMore({
      document: CATEGORIES_CREATED_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev
        const newItem = subscriptionData.data.categoryCreated

        // skip if already exists
        if (prev.categories.some((p) => p.id === newItem.id)) return prev

        return { ...prev, categories: [newItem, ...prev.categories] }
      },
      onError: (err) => console.log("[useQueryCategories][CATEGORIES_CREATED_SUBSCRIPTION]", err),
    }),
    result.subscribeToMore({
      document: CATEGORIES_UPDATED_SUBSCRIPTION,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev
        const updatedItem = subscriptionData.data.categoryUpdated
        let category = prev.categories.find((p) => p.id === updatedItem.id)
        if (category) {
          category = { ...updatedItem }
        }
        return prev
      },
      onError: (err) => console.log("[useQueryCategories][CATEGORIES_UPDATED_SUBSCRIPTION]", err),
    }),
  ]

const useQueryCategories = (options) => {
  const result = useQuery(CATEGORIES_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

  return {
    ...result,
    subscribe: subscribe(result),
  }
}

export { useQueryCategories, CATEGORIES_QUERY, CATEGORIES_FIELDS }
